import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import Hero from './components/Hero';
import About from "./components/About";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
// import Parallax from "./components/Parallax";
// import Slider from "./components/slider";
// import Head from "./components/head";

function App() {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    // Check system preference
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      setIsDark(true);
    }
  }, []);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDark]);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-white">
      <Header isDark={isDark} toggleTheme={toggleTheme} />
      {/* <Head /> */}
      {/* <Slider /> */}
      {/* <Parallax /> */}
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
